// @ts-nocheck
import { Link } from 'react-router-dom';
import { SimpleTextFilter } from '../../../common/Table';
import React from 'react';
import { useTranslation } from 'react-i18next';

const DisabledReasonsColumnsConfig = ({ params, filterChange }) => {
  const { t } = useTranslation();
  return [
    {
      Key: 'reason',
      Label: t('Reason'),
      width: '100%',
      Render: (disableReason) => (
        <Link to={'/settings/disabled-reason/' + disableReason.id}>
          {disableReason.reason}
        </Link>
      ),
      Filter: {
        Render: (col) => (
          <SimpleTextFilter
            Key={col.Key}
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value) => filterChange(col.Key, value)}
            testId="disabled-reason-name-filter"
          />
        ),
      },
    },
  ];
};



export default DisabledReasonsColumnsConfig;
